import { useLayoutEffect, useState } from 'react';

import useGetWindowSize from '../../../../hooks/useGetWindowSize';

const useGetCardWidth = (reel: React.MutableRefObject<HTMLUListElement | null>) => {
    const [cardWidth, setCardWidth] = useState<number | null>(null);
    const windowSize = useGetWindowSize();

    useLayoutEffect(() => {
        if (!reel.current || !reel.current.children.length || !windowSize) {
            return;
        }

        setCardWidth((reel.current.children[0] as HTMLElement).offsetWidth);
    }, [windowSize, reel]);

    return cardWidth;
};

export default useGetCardWidth;
